import * as React from 'react';

export const InvisibleCell = () => <th className="d-none" />;
